import React, { FC } from 'react';
import {
  CatIconCancelUndo,
  CatIconCube,
  CatIconReplace,
  CatIconWrench
} from 'components/blocks-components';
import { BUNDLE_BEAN, PACKAGE_BEAN } from '../constants/constants';
import styles from './common-availability-keys-icons.module.scss';

interface CommonAvailabilityKeysIconsProps {
  indirectReplacement: boolean;
  reman: boolean;
  nonReturnable: boolean;
  type: string;
  isCatCorp: boolean;
}

const CommonAvailabilityKeysIcons: FC<CommonAvailabilityKeysIconsProps> = ({
  indirectReplacement,
  reman,
  nonReturnable,
  type,
  isCatCorp
}) => {
  const isPackageOrBundleBean = type === PACKAGE_BEAN || type === BUNDLE_BEAN;

  return (
    <div className="d-flex gap-2 ms-2">
      {!isCatCorp && (
        <>
          {nonReturnable && (
            <CatIconCancelUndo
              data-testid="cat-icon-cancel-undo"
              className={styles['icon-color']}
            />
          )}
          {reman && (
            <CatIconWrench
              data-testid="cat-icon-wrench"
              className={styles['icon-color']}
            />
          )}
          {indirectReplacement && (
            <CatIconReplace
              data-testid="cat-icon-replace"
              className={styles['icon-color']}
            />
          )}
        </>
      )}
      {isPackageOrBundleBean && (
        <CatIconCube
          data-testid="cat-icon-cube"
          className={styles['icon-color']}
        />
      )}
    </div>
  );
};

export default CommonAvailabilityKeysIcons;
